<script>
import {
  ButtonElementMixin,
} from "%/dynamic-component-editor/standard-elements/button-element/button-element-mixin";
import ClickAction from "%/dynamic-component-editor/options/click-action";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";

export default {
  name: "ButtonElement",
  elementPanelSettings: {
    tags: ["button", "cta", "action"],
    displayName: "Button",
    displayIcon: "button",
    elementType: "element",
    elementGroup: "general",
  },
  extends: BaseButtonElement,
  mixins: [ButtonElementMixin],
  options: [
    ClickAction,
  ],
};
</script>

<style lang="scss" scoped>
</style>
